import axios from 'axios'
import * as tus from 'tus-js-client'
import { v4 as uuidv4 } from 'uuid'

import { message } from '@/components/shared/message'
import {
  getBaeTokenByCreatorId,
  requestBaeApi,
} from '@/utils/axios'
import { sleep } from '@/utils/dev-tools'

const checkVideoUpload = async (url: string) => {
  if (!url) return
  let retryTimes = 60
  while (retryTimes >= 0) {
    retryTimes--
    if (retryTimes <= 0) {
      void message.error('Upload failed, please retry')
      throw new Error('Upload failed, please retry')
    }
    try {
      await axios.get(url)
      return
    } catch (err) {
      console.error(err)
      await sleep(10)
    }
  }
  if (retryTimes <= 0) {
    throw new Error('Upload failed, please retry')
  }
}

export interface UploadParams {
  creatorId: number
  file: File
}
export const uploadVideo = async ({
  creatorId,
  file,
}: UploadParams) => {
  const uuid = uuidv4()
  const upload = new tus.Upload(file, {
    endpoint: 'https://videodeal-prod.bae.boo/files', // 上传的 endpoint
    retryDelays: [0, 3000, 5000, 10000], // 失败时重试间隔
    removeFingerprintOnSuccess: false, // 成功时删除标识
    metadata: {
      vid: uuid,
      if_mp4: file.name.toLowerCase().endsWith('.mp4') ? '1' : '0',
      if_cover: '1',
      type: 'video',
    },
    headers: {
      Authorization: getBaeTokenByCreatorId(creatorId) || '',
    },
    uploadSize: file.size, // 设置为整个文件大小，避免分块
    chunkSize: file.size, // 不分块上传，直接上传完整文件
  })
  upload.start()
  const videoUrl = `https://img.bae.boo/${uuid}.mp4`
  await checkVideoUpload(videoUrl)
  return videoUrl
}

export const uploadImage = async ({
  creatorId,
  file,
}: UploadParams) => {
  const formData = new FormData()
  const uuid = uuidv4()
  const fileExtension = file.name.split('.').pop()
  const newFileName = `${uuid}.${fileExtension}`

  formData.append('file', file, newFileName)
  const { data } = await requestBaeApi<{ urls: string[] }>({
    creatorId,
    url: 'https://picprod.mobus.workers.dev/uploadall',
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data.urls[0]
}
